<template>
  <div class="weather-fill">
    <p class="txt-p">所属类别：{{typeState(defaultOption.industryType)}}</p>
    <p class="txt-p">是否免停产： {{Whether(defaultOption.isAvoid)}}</p>
    <p class="txt-p">位于建成区： {{Whether(defaultOption.isUrban)}}</p>
    <p class="txt-p">是否错峰生产： {{Whether(defaultOption.isStagger)}}</p>
    <el-tabs v-model="activeName">
      <el-tab-pane label="排放数据" name="first">
        <div>
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="poll" label="污染物" width="115">
            </el-table-column>
            <el-table-column label="企业日排放量">
              <el-table-column prop="heating" label="供暖期">
              </el-table-column>
              <el-table-column prop="noheating" label="非供暖期">
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="I级预警" name="second">
        <div>
          <el-table :data="firstWarning" ref="first" style="width: 100%" border tooltip-effect="light"> 
            <el-table-column prop="poll" label="减排措施" width="115">
            </el-table-column>
            <el-table-column label="时期">
              <el-table-column prop="heating1" label="供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" class="txt-popover" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.heating1)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.heating1}}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="noheating1" label="非供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.noheating1)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.noheating1}}</div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-table :data="secondWarning" ref="first" style="width: 100%" border tooltip-effect="light"> 
            <el-table-column prop="poll" label="污染物" width="115">
            </el-table-column>
            <el-table-column label="减排量">
              <el-table-column prop="heating1" label="供暖期" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="noheating1" label="非供暖期" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="II级预警" name="third">
        <div>
          <el-table :data="firstWarning" style="width: 100%; table-layout:fixed;" border tooltip-effect="light" >
            <el-table-column prop="poll" label="减排措施" width="115">
            </el-table-column>
            <el-table-column label="时期">
              <el-table-column prop="heating2" label="供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.heating2)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.heating2}}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="noheating2" label="非供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.noheating2)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.noheating2}}</div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-table :data="secondWarning" style="width: 100%" border tooltip-effect="light">
            <el-table-column prop="poll" label="污染物" width="115">
            </el-table-column>
            <el-table-column label="减排量">
              <el-table-column prop="heating2" label="供暖期" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="noheating2" label="非供暖期" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="III级预警" name="fourth">
        <div>
          <el-table :data="firstWarning" style="width: 100%" border tooltip-effect="light">
            <el-table-column prop="poll" label="减排措施" width="115">
            </el-table-column>
            <el-table-column label="时期">
              <el-table-column prop="heating3" label="供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.heating3)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.heating3}}</div>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="noheating3" label="非供暖期">
                <template slot-scope="scope">
                  <el-popover width="800" trigger="hover">
                    <span class="txt-popover" v-html="formatLine(scope.row.noheating3)"></span>
                    <div class="txt-td" slot="reference">{{scope.row.noheating3}}</div>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
          <el-table :data="secondWarning" style="width: 100%" border tooltip-effect="light">
            <el-table-column prop="poll" label="污染物" width="115">
            </el-table-column>
            <el-table-column label="减排量">
              <el-table-column prop="heating3" label="供暖期" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="noheating3" label="非供暖期" show-overflow-tooltip>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import WorkBrnch from './../../data/basic/others/other.js'
export default {
  data() {
    return {
      defaultOption: {},
      activeName: 'first',
      tableData: [],
      firstWarning: [],
      secondWarning: [],
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    let currQyInfo = sessionStorage.planIdLists
    this.get_heavypoll_detail({
      planId: currQyInfo
    })
  },
  methods: {
    formatLine(val){
      if(!val) return '';
      return val.replace(/[\n]/g,'<br/>');
    },
    formatTab(obj) {
      //1=供暖期，2=非供暖期
      let heating_emissionData = obj.find((data) => data.period == 1)
      let noheating_emissionData = obj.find((data) => data.period == 2)

      let tabArr = [{
          poll: '二氧化硫(kg)',
          heating: heating_emissionData.emissionSO2,
          noheating: noheating_emissionData.emissionSO2,
        },
        {
          poll: '烟、粉尘(kg)',
          heating: heating_emissionData.emissionDust,
          noheating: noheating_emissionData.emissionDust,
        },
        {
          poll: '氮氧化物(kg)',
          heating: heating_emissionData.emissionNOx,
          noheating: noheating_emissionData.emissionNOx,
        },
        {
          poll: 'VOCs(kg)',
          heating: heating_emissionData.emissionVOCs,
          noheating: noheating_emissionData.emissionVOCs,
        },
        {
          poll: '总计(kg)',
          heating: heating_emissionData.emissionTotal,
          noheating: noheating_emissionData.emissionTotal,
        }
      ]
      this.tableData = tabArr
    },
    formatStrategyType(id) {
      let type = ''
      switch (id) {
        case 1:
          type = '临时管控'
          break
        case 2:
          type = '轮流停产'
          break
        case 3:
          type = '加强管理'
          break
        case 4:
          type = '错峰生产'
          break
      }
      return type
    },
    formatIsHeavy(bool) {
      return bool ? '是' : '否'
    },
    // 是否免停产
    Whether(type) {
      return type ? '是' : '否'
    },
    // 行业
    typeState(val) {
      let industryType = ''
      switch (val) {
        case 1:
          industryType = '钢铁-G'
          break
        case 2:
          industryType = '焦化-J'
          break
        case 3:
          industryType = '水泥-S'
          break
        case 4:
          industryType = '玻璃-B'
          break
        case 5:
          industryType = '医药-Y'
          break
        case 6:
          industryType = '化工-H'
          break
        case 7:
          industryType = '危险废物处置(利用)-W'
          break
        case 8:
          industryType = '铸造-ZZ'
          break
        case 9:
          industryType = '火电-HD'
          break
        case 10:
          industryType = '涉Voc（除医药、化工）-V'
          break
        case 11:
          industryType = '建材（除水泥）-JC'
          break
        case 12:
          industryType = '高架源-GJ'
          break
        case 13:
          industryType = '碳素（包括炭黑）-TS'
          break
        case 99:
          industryType = '其他-Q'
          break
      }
      return industryType
    },
    formatfirstWarning(arr) {
      //1=供暖期，2=非供暖期
      let heating_strategy = arr.find((data) => data.period == 1).strategy
      let noheating_strategy = arr.find((data) => data.period == 2).strategy

      //等级,1=I级，2=II级，3=III级，4=IV级
      let heating_level1 = heating_strategy.find((data) => data.level == 1);
      let heating_level2 = heating_strategy.find((data) => data.level == 2);
      let heating_level3 = heating_strategy.find((data) => data.level == 3);

      let noheating_level1 = noheating_strategy.find((data) => data.level == 1);
      let noheating_level2 = noheating_strategy.find((data) => data.level == 2);
      let noheating_level3 = noheating_strategy.find((data) => data.level == 3);

      let newarr = [
        {
          poll: '措施详情',
          heating1: heating_level1.measure[0].method,
          noheating1: noheating_level1.measure[0].method,
          heating2: heating_level2.measure[0].method,
          noheating2: noheating_level2.measure[0].method,
          heating3: heating_level3.measure[0].method,
          noheating3: noheating_level3.measure[0].method,
        },
        {
          poll: '重型车停运',
          heating1: this.formatIsHeavy(heating_level1.measure[0].isVehicleControl),
          noheating1: this.formatIsHeavy(noheating_level1.measure[0].isVehicleControl),
          heating2: this.formatIsHeavy(heating_level2.measure[0].isVehicleControl),
          noheating2: this.formatIsHeavy(noheating_level2.measure[0].isVehicleControl),
          heating3: this.formatIsHeavy(heating_level3.measure[0].isVehicleControl),
          noheating3: this.formatIsHeavy(noheating_level3.measure[0].isVehicleControl),
        },
      ]
      return newarr
    },
    formatsecondWarning(arr) {
      //1=供暖期，2=非供暖期
      let heating_strategy = arr.find((data) => data.period == 1).strategy
      let noheating_strategy = arr.find((data) => data.period == 2).strategy

      //等级,1=I级，2=II级，3=III级，4=IV级
      let heating_level1 = heating_strategy.find((data) => data.level == 1);
      let heating_level2 = heating_strategy.find((data) => data.level == 2);
      let heating_level3 = heating_strategy.find((data) => data.level == 3);

      let noheating_level1 = noheating_strategy.find((data) => data.level == 1);
      let noheating_level2 = noheating_strategy.find((data) => data.level == 2);
      let noheating_level3 = noheating_strategy.find((data) => data.level == 3);

      let newarr = [
        {
          poll: '二氧化硫(kg)',
          heating1: heating_level1.measure[0].expectSO2,
          noheating1: noheating_level1.measure[0].expectSO2,
          heating2: heating_level2.measure[0].expectSO2,
          noheating2: noheating_level2.measure[0].expectSO2,
          heating3: heating_level3.measure[0].expectSO2,
          noheating3: noheating_level3.measure[0].expectSO2,
        },
        {
          poll: '烟、粉尘(kg)',
          heating1: heating_level1.measure[0].expectDust,
          noheating1: noheating_level1.measure[0].expectDust,
          heating2: heating_level2.measure[0].expectDust,
          noheating2: noheating_level2.measure[0].expectDust,
          heating3: heating_level3.measure[0].expectDust,
          noheating3: noheating_level3.measure[0].expectDust,
        },
        {
          poll: '氮氧化物(kg)',
          heating1: heating_level1.measure[0].expectNOx,
          noheating1: noheating_level1.measure[0].expectNOx,
          heating2: heating_level2.measure[0].expectNOx,
          noheating2: noheating_level2.measure[0].expectNOx,
          heating3: heating_level3.measure[0].expectNOx,
          noheating3: noheating_level3.measure[0].expectNOx,
        },
        {
          poll: 'VOCs(kg)',
          heating1: heating_level1.measure[0].expectVOCs,
          noheating1: noheating_level1.measure[0].expectVOCs,
          heating2: heating_level2.measure[0].expectVOCs,
          noheating2: noheating_level2.measure[0].expectVOCs,
          heating3: heating_level3.measure[0].expectVOCs,
          noheating3: noheating_level3.measure[0].expectVOCs,
        },
        {
          poll: '总计(kg)',
          heating1: heating_level1.measure[0].expectTotal,
          noheating1: noheating_level1.measure[0].expectTotal,
          heating2: heating_level2.measure[0].expectTotal,
          noheating2: noheating_level2.measure[0].expectTotal,
          heating3: heating_level3.measure[0].expectTotal,
          noheating3: noheating_level3.measure[0].expectTotal,
        },
      ]
      return newarr
    },
    // 获取原概要
    get_heavypoll_detail(params) {
      (async() => {
        try {
          let info = await WorkBrnch.heavypoll_detail(params)
          this.defaultOption = info.data
          this.formatTab(info.data.emissionData)
          this.firstWarning = this.formatfirstWarning(this.defaultOption.emissionData)
          this.secondWarning = this.formatsecondWarning(this.defaultOption.emissionData)
        } catch (err) {
          console.log(err)
        }
      })()
    },
  },
}

</script>
<style scoped>
.weather-fill {
  width: 100%;
  height: 100%;
}

.txt-p {
  font-size: 14px;
  line-height: 25px;
  margin-bottom: 5px;
  padding-left: 5px;
}

.txt-td{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.txt-popover{
    width: 500px;
    height: 100px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// numberinfo.vue?457e2633